/* eslint-disable prettier/prettier */
/* eslint-disable no-unused-vars */
import { Box, Button, Heading, HStack, Image, Stack, Text, Wrap, WrapItem } from '@chakra-ui/react';
import React, { useEffect, useState } from 'react';
import {
  PolarAngleAxis,
  PolarGrid,
  PolarRadiusAxis,
  Radar,
  RadarChart,
  ResponsiveContainer,
} from 'recharts';
import logo from '../../assets/images/logo_black.png';
import CardCounts from '../../components/cardsCounts';
import CardWithGraphic from '../../components/CardWithGraphic';
import ModalTeamIndicator from '../../components/ModalTeamIndicator';
import { DataSkeleton, EmptyState, ErrorState } from '../../components/states';
import { useFetch } from '../../hooks/useFetch';
import { useAuth } from '../../providers/auth';

export const Home = () => {
  const {
    requestApi: reqApiCounts,
    data: dataCounts,
    loading: loadingCounts,
    error: countsError,
  } = useFetch('v1/admin/dashboard/counts');
  const {
    requestApi: reqApiDashboard,
    data: dataDashboard,
    loading: loadingDashboard,
    error: dashboardError,
  } = useFetch('v1/admin/dashboard');
  const {
    requestApi: reqApiInstitutions,
    data: dataInstitutions,
    loading: loadingInstitutions,
    error: institutionsError,
  } = useFetch('v1/admin/dashboard/institutions');
  const minLimit = 0; // Set your minimum limit here
  const maxLimit = 10; // Set your maximum limit here
  const [open, setOpen] = useState(false);
  const [id, setId] = useState('');
  const { user } = useAuth();

  const loadDashboard = () => {
    reqApiCounts('get');
    reqApiDashboard('get');
    reqApiInstitutions('get');
  };

  useEffect(() => {
    loadDashboard();
  }, []);
  return (
    <Box>
      <HStack justify="space-between">
        <Heading as="h6" fontSize="30px" fontWeight="300">
          Bem-vindo ao Painel Administrativo
        </Heading>
        <Image src={logo} style={{ width: 200 }} />
      </HStack>
      {countsError || dashboardError || institutionsError ? (
        <Box my={6}>
          <ErrorState description="O painel não foi atualizado." onRetry={loadDashboard} />
        </Box>
      ) : null}
      {!countsError && (loadingCounts || !dataCounts) && !dataCounts?.data && (
        <DataSkeleton variant="cards" rows={5} label="Carregando indicadores do painel" />
      )}
      {!countsError && dataCounts?.data && (
        <Stack flex={1} mb="50px" p="30px 0">
          <Wrap spacing="20px">
            {user?.group?.id !== 7 && (
              <WrapItem>
                <CardCounts
                  title="Total de Instituições"
                  subtitle={dataCounts?.data?.total_institutions}
                />
              </WrapItem>
            )}
            {user?.group?.id !== 3 && (
              <WrapItem>
                <CardCounts title="Total de Tutores" subtitle={dataCounts?.data?.total_tutors} />
              </WrapItem>
            )}
            <WrapItem>
              <CardCounts
                title="Total de Professores"
                subtitle={dataCounts?.data?.total_teachers}
              />
            </WrapItem>
            <WrapItem>
              <CardCounts title="Total de Alunos" subtitle={dataCounts?.data?.total_children} />
            </WrapItem>
            <WrapItem>
              <CardCounts
                title="Total de Responsáveis"
                subtitle={dataCounts?.data?.total_responsibles}
              />
            </WrapItem>
          </Wrap>
        </Stack>
      )}
      {user?.group?.id === 6 && (
        <Box mb="50px">
          <Text mb={22} fontWeight="400" fontSize={18} color="#34353E">
            Indicadores Secretaria:
          </Text>
          {!dashboardError && (loadingDashboard || !dataDashboard) && !dataDashboard?.data && (
            <DataSkeleton variant="cards" rows={1} label="Carregando gráfico do painel" />
          )}
          {!dashboardError && dataDashboard?.data?.length > 0 && (
            <HStack
              w="700px"
              h="400px"
              background="theme.light.bodySecondary"
              borderRadius="5px"
              overflow="auto"
            >
              <ResponsiveContainer width="75%" height={350}>
                <RadarChart cx="50%" cy="50%" outerRadius="75%" data={dataDashboard?.data ?? []}>
                  <PolarGrid />
                  <PolarAngleAxis dataKey="name" />
                  <PolarRadiusAxis domain={[minLimit, maxLimit]} axisLine={false} tick={false} />
                  <Radar name="name" dataKey="average" stroke="#16B1FF" fill="#16B1FF" />
                </RadarChart>
              </ResponsiveContainer>
              <Box overflow="auto" h="100%" w="30%">
                <Text mb="8px" mt={10}>
                  Notas:
                </Text>
                {dataDashboard?.data?.map((item, index) => (
                  <HStack key={item.name || index} w="140px" justify="space-between" mb="8px">
                    <Text>{item.name}</Text>
                    <Text>{parseFloat(item.average).toFixed(1)}</Text>
                  </HStack>
                ))}
              </Box>
            </HStack>
          )}
          {!dashboardError &&
            !loadingDashboard &&
            dataDashboard &&
            !dataDashboard?.data?.length && (
              <EmptyState
                title="Nenhum indicador encontrado"
                description="Não existem avaliações disponíveis para este painel."
              />
            )}
        </Box>
      )}
      <Stack flex={1}>
        {!institutionsError &&
          (loadingInstitutions || !dataInstitutions) &&
          !dataInstitutions?.data && (
            <DataSkeleton variant="cards" rows={3} label="Carregando instituições" />
          )}
        {!institutionsError && dataInstitutions?.data?.length > 0 && (
          <Wrap spacing="20px">
            {dataInstitutions?.data?.map((institution) => (
              <WrapItem
                key={institution?.id}
                onClick={() => {
                  setOpen(!open);
                  setId(institution?.id);
                }}
              >
                <CardWithGraphic data={institution.ratings} institutionName={institution.name} />
              </WrapItem>
            ))}
          </Wrap>
        )}
        {!institutionsError &&
          !loadingInstitutions &&
          dataInstitutions &&
          !dataInstitutions?.data?.length && (
            <EmptyState
              title="Nenhuma instituição encontrada"
              description="Não existem instituições com indicadores disponíveis."
            />
          )}
      </Stack>
      <ModalTeamIndicator
        id={id}
        alertMsg="abc"
        useSecondaryActions={open}
        msgStatus="warning"
        ConfirmButton={
          <Button w="200px" boxShadow="0px 2px 4px #00000050" onClick={() => setOpen(!open)} h={10}>
            fechar
          </Button>
        }
      />
    </Box>
  );
};
